/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_General_Settings_LabelInputs */

const en_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Settings`)
};

const fr_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametres generaux`)
};

const de_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Einstellungen`)
};

const it_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni generali`)
};

const ru_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общие настройки`)
};

const es_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración general`)
};

const zh_cn2_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常规设置`)
};

const ja_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般設定`)
};

const hi_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य सेटिंग्स`)
};

const pt_pt2_style_guide_manager_general_settings_label = /** @type {(inputs: Style_Guide_Manager_General_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações gerais`)
};

/**
* | output |
* | --- |
* | "General Settings" |
*
* @param {Style_Guide_Manager_General_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_general_settings_label = /** @type {((inputs?: Style_Guide_Manager_General_Settings_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_General_Settings_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_general_settings_label(inputs)
	if (locale === "de") return de_style_guide_manager_general_settings_label(inputs)
	if (locale === "it") return it_style_guide_manager_general_settings_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_general_settings_label(inputs)
	if (locale === "es") return es_style_guide_manager_general_settings_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_general_settings_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_general_settings_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_general_settings_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_general_settings_label(inputs)
	return en_style_guide_manager_general_settings_label(inputs)
});